import { CONFIG_CODE } from 'constants/common'
import { useEffect, useRef, useState } from 'react'
import { appService } from 'services/appService'

const useSafeParams = () => {
    const [whitelist, setWhitelist] = useState(['google', 'viettel-cloud', 'qni', 'vpqh', 'ubhn', 'sme', 'nq57', 'qcabinet'])
    const fetched = useRef(null)

    const getProvider = (provider) => {
        if (whitelist && whitelist.includes(provider)) return provider;
        return ''
    }

    const fetchWhitelist = async () => {
        try {
            const res = await appService.getOneConfig(
                CONFIG_CODE.WHITELIST_PROVIDER
            );

            setWhitelist(res?.value?.split(',').map(provider => provider.trim()).filter(Boolean) || []);
        } catch (error) {
            setWhitelist([])
        }
    };

    useEffect(() => {
        if (!fetched.current) {
            fetched.current = true;
            fetchWhitelist()
        }
    }, [])

    return {
        getProvider,
        isReady: whitelist !== null
    }
}

export default useSafeParams
